import { render, staticRenderFns } from "./FormsListToolbar.vue?vue&type=template&id=e2c21738&"
import script from "./FormsListToolbar.vue?vue&type=script&lang=js&"
export * from "./FormsListToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports